import script from "./EnquiriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./EnquiriesList.vue?vue&type=script&setup=true&lang=js"

import "./EnquiriesList.vue?vue&type=style&index=0&id=28c5017a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c5017a"]])

export default __exports__